export default __webpack_public_path__ + "static/media/pic-1.3806a6fa.jpg";